import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class ExportHistoricoPlacaService {
  constructor(private httpClient: HttpClient) {}
  exportHistoricoBastidor = endpointsURL.exportHistoricoBastidor;
  env = environment.env;

  public getFile(filters: string) {
    return this.httpClient.get(
      `${this.env}${this.exportHistoricoBastidor}${filters}`,
      {
        responseType: "blob",
      }
    );
  }
}
